export interface Env {
  VITE_API_OLD_ENDPOINT: string
  SENTRY_AUTH_TOKEN: string
  VITE_SENTRY_DSN: string
  VITE_SENTRY_ENABLED: "true" | "false"
  VITE_SENTRY_ENVIRONMENT: "local" | "staging" | "prod"
  VITE_API_MOCK: "true" | "false"
  BACKEND_URL: string
}

export function validateEnv(env: Record<string, unknown>): Env {
  const errors: string[] = []

  if (env.VITE_API_MOCK === "true") {
    return env as unknown as Env
  }

  // Validate DSN
  if (!env.VITE_SENTRY_DSN || typeof env.VITE_SENTRY_DSN !== "string") {
    errors.push("VITE_SENTRY_DSN must be a valid URL string")
  }

  // Validate ENABLED
  if (!["true", "false"].includes(env.VITE_SENTRY_ENABLED as string)) {
    errors.push('VITE_SENTRY_ENABLED must be either "true" or "false"')
  }

  // Validate ENVIRONMENT
  if (
    !["local", "staging", "prod"].includes(
      env.VITE_SENTRY_ENVIRONMENT as string
    )
  ) {
    errors.push("VITE_SENTRY_ENVIRONMENT must be one of: local, staging, prod")
  }

  // Validate API_MOCK
  if (!["true", "false"].includes(env.VITE_API_MOCK as string)) {
    errors.push('VITE_API_MOCK must be either "true" or "false"')
  }

  if (!env.VITE_API_OLD_ENDPOINT || typeof env.VITE_API_OLD_ENDPOINT !== "string") {
    errors.push("VITE_API_OLD_ENDPOINT must be a valid URL string")
  }

  if (errors.length > 0) {
    throw new Error(errors.join("\n"))
  }

  const validatedEnv = env as unknown as Env

  return {
    ...validatedEnv,
    VITE_API_OLD_ENDPOINT: validatedEnv.VITE_API_OLD_ENDPOINT.replace(/\/$/, ""), // Remove trailing slash if it exists
  } as Env
}
